
 /*
  *****************************************************************************
  * WARNING: This file is automatically generated.
  * Do not edit this file manually.
  *****************************************************************************
  *
  * The source file is located at:
  *   /codebuild/output/src1738611268/src/vl-app/pages/linklogin.tsx
  */

import { createFileRoute } from '@tanstack/react-router';
import React from 'react';
import { Page } from '@helpers/types';
import LoginLayout from '@components/Layouts/Login';
import RestrictedAccessView from '@components/Login/views/RestrictedAccessView';

const LinkLogin: Page = () => (
  <LoginLayout>
    <RestrictedAccessView isNHS />
  </LoginLayout>
);


export const Route = createFileRoute('/linklogin')({ component: LinkLogin });
